import { getBestMatchedSearchListing } from '../../utils/getBestMatchedSearchListing';

import type { CountryISO } from '@/constants/countries';

import type {
  AlgoliaBatchSearchResults,
  AlgoliaBatchSearchResult,
} from './useCompanyBatchSearch';

type Hits = AlgoliaBatchSearchResult['hits'];

const filterHits = (hits: Hits, include: Hits[number]['type'][]): Hits => {
  return hits.filter((result) => {
    return include.includes(result.type);
  });
};

export const getMatchedListingsMap = (
  data: AlgoliaBatchSearchResults,
  countryISO?: CountryISO
) =>
  data.reduce<Record<string, ReturnType<typeof getBestMatchedSearchListing>>>(
    (a, b) => {
      const { hits, query } = b;

      const [first] = filterHits(hits, ['company']);

      if (first === undefined) {
        a[query] = null;
        return a;
      }

      const listing = getBestMatchedSearchListing({
        query: query,
        company: first,
        countryISO,
      });

      a[query] = listing;

      return a;
    },
    {}
  );
